var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGold2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gold",
    xmlns: "http://www.w3.org/2000/svg",
    width: 476.9,
    height: 69.699,
    viewBox: "0 0 476.9 69.699",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_85028",
    "data-name": "Group 85028"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82601",
    "data-name": "Path 82601",
    d: "M96.1,50.6H94L83,17.3h2.7L95,46.2l9.4-28.9h2.7Z",
    fill: "#d3af70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82602",
    "data-name": "Path 82602",
    d: "M137.7,50.6l-2.9-8.1H119.3l-2.9,8.1h-2.7L126,17.3h2.2l12.3,33.3ZM127,20.7l-7,19.6h14Z",
    fill: "#d3af70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82603",
    "data-name": "Path 82603",
    d: "M166.7,45a9.621,9.621,0,0,1-2,3.2,9.451,9.451,0,0,1-3.1,2.1,10.7,10.7,0,0,1-4.1.7,9.869,9.869,0,0,1-7.3-2.9l1.7-1.7a7.349,7.349,0,0,0,2.2,1.6,6.387,6.387,0,0,0,3.4.7,6.811,6.811,0,0,0,5.5-2.2,9.025,9.025,0,0,0,1.9-6.2v-23h2.5V40.8A11.581,11.581,0,0,1,166.7,45Z",
    fill: "#d3af70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82604",
    "data-name": "Path 82604",
    d: "M203.9,50.6l-8-15.3h-9.2V50.6h-2.5V17.3h12.7a12.088,12.088,0,0,1,3.8.6,8.719,8.719,0,0,1,3,1.7,7.175,7.175,0,0,1,2,2.8,9.2,9.2,0,0,1,.7,3.8,8.867,8.867,0,0,1-2.1,6.1,9.782,9.782,0,0,1-5.6,2.9l8,15.4Zm-.5-27.3a8.008,8.008,0,0,0-1.5-2.1,5.1,5.1,0,0,0-2.3-1.2,9.246,9.246,0,0,0-2.9-.4h-9.8V33.1h9.8a8.85,8.85,0,0,0,2.9-.4,7.139,7.139,0,0,0,2.3-1.2,5.106,5.106,0,0,0,1.5-2.1,6.742,6.742,0,0,0,.5-3A6.156,6.156,0,0,0,203.4,23.3Z",
    fill: "#d3af70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82605",
    "data-name": "Path 82605",
    d: "M241.6,50.6l-2.9-8.1H223.2l-2.9,8.1h-2.7l12.3-33.3h2.2l12.3,33.3ZM231,20.7l-7,19.6h13.9Z",
    fill: "#d3af70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82606",
    "data-name": "Path 82606",
    d: "M297.1,43.6a9.1,9.1,0,0,1-2.1,3.5,10.8,10.8,0,0,1-3.9,2.8,11.172,11.172,0,0,1-4.8,1,11.3,11.3,0,0,1-4.5-.9,11.947,11.947,0,0,1-3.8-2.5,13.014,13.014,0,0,1-1.8-2.3,10.708,10.708,0,0,1-.9-2.7,30.294,30.294,0,0,1-.4-3.6V29.2a12.768,12.768,0,0,1,.4-3.6,13.088,13.088,0,0,1,.9-2.8,7.606,7.606,0,0,1,1.8-2.3,11.947,11.947,0,0,1,3.8-2.5,11.3,11.3,0,0,1,4.5-.9,11.047,11.047,0,0,1,4.1.7,10.531,10.531,0,0,1,3.4,2,10.994,10.994,0,0,1,2.5,3.1,12.64,12.64,0,0,1,1.4,4h-2.5a9.744,9.744,0,0,0-3.1-5.5,8.8,8.8,0,0,0-5.7-2,7.973,7.973,0,0,0-3.4.7,8.123,8.123,0,0,0-2.9,1.9,6.222,6.222,0,0,0-1.4,1.9,13.492,13.492,0,0,0-.8,2.4,15.477,15.477,0,0,0-.3,3.3c0,1.3-.1,2.8-.1,4.6s0,3.3.1,4.6a26.772,26.772,0,0,0,.3,3.3,8.469,8.469,0,0,0,.8,2.4,6.222,6.222,0,0,0,1.4,1.9,8.123,8.123,0,0,0,2.9,1.9,9.828,9.828,0,0,0,3.4.7,9.954,9.954,0,0,0,3.8-.8,7.257,7.257,0,0,0,3.1-2.4,8.927,8.927,0,0,0,1.5-2.9,13.243,13.243,0,0,0,.5-3.7v-3h-8.9V34h11.5v5A25.617,25.617,0,0,1,297.1,43.6Z",
    fill: "#d3af70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82607",
    "data-name": "Path 82607",
    d: "M313.6,50.6V17.3h2.5V48.4h17.7v2.2H313.6Z",
    fill: "#d3af70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82608",
    "data-name": "Path 82608",
    d: "M367,38.9a12.768,12.768,0,0,1-.4,3.6,10.709,10.709,0,0,1-.9,2.7,7.606,7.606,0,0,1-1.8,2.3,11.947,11.947,0,0,1-3.8,2.5,11.7,11.7,0,0,1-9,0,11.947,11.947,0,0,1-3.8-2.5,13.014,13.014,0,0,1-1.8-2.3,10.708,10.708,0,0,1-.9-2.7,30.294,30.294,0,0,1-.4-3.6V29.2a12.768,12.768,0,0,1,.4-3.6,13.088,13.088,0,0,1,.9-2.8,7.606,7.606,0,0,1,1.8-2.3,11.947,11.947,0,0,1,3.8-2.5,11.7,11.7,0,0,1,9,0,11.947,11.947,0,0,1,3.8,2.5,13.014,13.014,0,0,1,1.8,2.3,10.236,10.236,0,0,1,.9,2.8,30.294,30.294,0,0,1,.4,3.6v9.7Zm-2.5-9.5a26.772,26.772,0,0,0-.3-3.3,8.469,8.469,0,0,0-.8-2.4,6.222,6.222,0,0,0-1.4-1.9,8.123,8.123,0,0,0-2.9-1.9,9.828,9.828,0,0,0-3.4-.7,7.973,7.973,0,0,0-3.4.7,8.123,8.123,0,0,0-2.9,1.9,6.222,6.222,0,0,0-1.4,1.9,13.492,13.492,0,0,0-.8,2.4,15.477,15.477,0,0,0-.3,3.3c0,1.3-.1,2.8-.1,4.6s0,3.3.1,4.6a26.772,26.772,0,0,0,.3,3.3,8.469,8.469,0,0,0,.8,2.4,6.222,6.222,0,0,0,1.4,1.9,8.123,8.123,0,0,0,2.9,1.9,9.828,9.828,0,0,0,3.4.7,7.973,7.973,0,0,0,3.4-.7,8.123,8.123,0,0,0,2.9-1.9,6.222,6.222,0,0,0,1.4-1.9,13.492,13.492,0,0,0,.8-2.4,15.477,15.477,0,0,0,.3-3.3c0-1.3.1-2.8.1-4.6C364.5,32.2,364.5,30.7,364.5,29.4Z",
    fill: "#d3af70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82609",
    "data-name": "Path 82609",
    d: "M404.8,45.5a7.175,7.175,0,0,1-2,2.8,8.509,8.509,0,0,1-3.1,1.7,12.451,12.451,0,0,1-4,.6H383.1V17.3h12.3a11.224,11.224,0,0,1,3.8.6,10.3,10.3,0,0,1,3.1,1.7,7.621,7.621,0,0,1,2,2.7A8.729,8.729,0,0,1,405,26a8.632,8.632,0,0,1-1.4,4.7,6.729,6.729,0,0,1-3.8,2.8,8.161,8.161,0,0,1,4.2,3,8.447,8.447,0,0,1,1.5,5A11.467,11.467,0,0,1,404.8,45.5Zm-3-22.4a5.264,5.264,0,0,0-1.6-2,6.591,6.591,0,0,0-2.4-1.1,13.523,13.523,0,0,0-2.9-.4h-9.5V32.5h9.5a9.667,9.667,0,0,0,2.9-.4,6.59,6.59,0,0,0,2.4-1.1,5.264,5.264,0,0,0,1.6-2,6.527,6.527,0,0,0,.6-2.9A6.678,6.678,0,0,0,401.8,23.1Zm-.9,13.4a8.1,8.1,0,0,0-5.5-1.8h-9.8V48.4h9.8a8.1,8.1,0,0,0,5.5-1.8,6.279,6.279,0,0,0,2.1-5A6.491,6.491,0,0,0,400.9,36.5Z",
    fill: "#d3af70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82610",
    "data-name": "Path 82610",
    d: "M441.1,50.6l-2.9-8.1H422.7l-2.9,8.1H417l12.3-33.3h2.2l12.3,33.3ZM430.4,20.7l-7,19.6h13.9Z",
    fill: "#d3af70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82611",
    "data-name": "Path 82611",
    d: "M456.7,50.6V17.3h2.5V48.4h17.7v2.2H456.7Z",
    fill: "#d3af70"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_85029",
    "data-name": "Group 85029"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82612",
    "data-name": "Path 82612",
    d: "M9.2,0,0,16.6H18.4Z",
    fill: "#d3af70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82613",
    "data-name": "Path 82613",
    d: "M28.4,34.4,19.2,17.9,9.9,34.4Z",
    fill: "#d3af70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82614",
    "data-name": "Path 82614",
    d: "M39,17.9,29.8,34.4H48.3Z",
    fill: "#d3af70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82615",
    "data-name": "Path 82615",
    d: "M29.1,35.7,19.9,52.3H38.3Z",
    fill: "#d3af70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82616",
    "data-name": "Path 82616",
    d: "M49,0,39.8,16.6H58.2Z",
    fill: "#d3af70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82617",
    "data-name": "Path 82617",
    d: "M49,34l9.2-16.6H39.8Z",
    fill: "#d3af70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82618",
    "data-name": "Path 82618",
    d: "M0,17.4,9.2,34l9.2-16.6Z",
    fill: "#d3af70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82619",
    "data-name": "Path 82619",
    d: "M39,51.8l9.3-16.5H29.8Z",
    fill: "#d3af70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82620",
    "data-name": "Path 82620",
    d: "M9.9,35.3l9.3,16.5,9.2-16.5Z",
    fill: "#d3af70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82621",
    "data-name": "Path 82621",
    d: "M29.1,69.7l9.2-16.6H19.9Z",
    fill: "#d3af70"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold2);
export default __webpack_public_path__ + "static/media/Gold (2).a7ec37002f755f4b148bbc0de9ca506a.svg";
export { ForwardRef as ReactComponent };